var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document/mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3566 20.144H4.6423C3.85516 20.144 3.21373 19.504 3.21373 18.7154V8.6754L11.2537 14.4154C11.6266 14.684 12.0623 14.8168 12.4994 14.8168C12.9366 14.8168 13.3723 14.684 13.7452 14.4168L21.7852 8.6754V18.7154C21.7852 19.504 21.1437 20.144 20.3566 20.144ZM4.6423 5.85826H20.3566C21.0309 5.85826 21.5709 6.33683 21.7209 6.9654L12.9137 13.2554C12.6652 13.4311 12.3323 13.4325 12.0837 13.254L3.27801 6.9654C3.42801 6.33683 3.96801 5.85826 4.6423 5.85826ZM20.3566 4.42969H4.6423C3.06658 4.42969 1.78516 5.71112 1.78516 7.28683V18.7154C1.78516 20.2911 3.06658 21.5725 4.6423 21.5725H20.3566C21.9323 21.5725 23.2137 20.2911 23.2137 18.7154V7.28683C23.2137 5.71112 21.9323 4.42969 20.3566 4.42969Z",
    fill: "#005FC8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.28dce080.svg";
export { ForwardRef as ReactComponent };